import initializeOptionsSlider from "./blocks/opinions-slider";
import initializeButton from "./button";
import initializeMobileMenu from "./menu";
import initializeBox from "./blocks/box";

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 600,

            });
        });

        initializeOptionsSlider();
        initializeButton();
        initializeMobileMenu();
        initializeBox();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
